module.exports = __webpack_public_path__ + "media/application/images/icons/bm-4bd5a27a5dc40543fea4027296e5ae4c.svg";